var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup504(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7878,
    cy: 30.2126,
    r: 29.7878,
    fill: "#FEDC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4837 43.0912C37.4837 44.0924 36.7674 45.0972 35.3952 45.8798C34.0373 46.6542 32.128 47.1491 29.9918 47.1491C27.8557 47.1491 25.9464 46.6542 24.5885 45.8798C23.2162 45.0972 22.5 44.0924 22.5 43.0912C22.5 42.5978 22.6679 42.2487 22.9664 41.9742C23.2835 41.6827 23.7771 41.4501 24.4622 41.2785C25.8382 40.9339 27.7728 40.8838 29.9918 40.8838C32.2109 40.8838 34.1455 40.9339 35.5215 41.2785C36.2065 41.4501 36.7002 41.6827 37.0172 41.9742C37.3158 42.2487 37.4837 42.5978 37.4837 43.0912Z",
    fill: "white",
    stroke: "#B4643A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2653,
    cy: 28.0329,
    r: 7.26531,
    fill: "#B4643A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3592,
    cy: 26.58,
    r: 2.90612,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8983,
    cy: 28.7597,
    r: 2.17959,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8124,
    cy: 32.3925,
    r: 1.45306,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0583,
    cy: 28.0329,
    r: 7.26531,
    fill: "#B4643A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1522,
    cy: 26.58,
    r: 2.90612,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6913,
    cy: 28.7597,
    r: 2.17959,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6054,
    cy: 32.3925,
    r: 1.45306,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 38,
    rx: 4,
    ry: 2,
    fill: "#FF9C8E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 38,
    rx: 4.5,
    ry: 2,
    fill: "#FF9C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup504);
export default __webpack_public_path__ + "static/media/Group 504.e5ffdfb33d5759391fc1bc9b56dd32e5.svg";
export { ForwardRef as ReactComponent };